import capitalizeWords from '@/helpers/capitalize-words';

export default {
    methods: {
        capitalize(string) {
            return capitalizeWords(string);
        },
    },
};
